import React from "react";
import { numberWithCommas } from "@whatslly/commons/utils";
import type { LicenseData } from "../../types/LicenseData";
import { useTranslation } from "react-i18next";
import styles from "./page-header.module.scss";
import { FaUserShield, FaUserCheck, FaRegIdCard } from "react-icons/fa6";
import { TuvisSkeleton } from "@whatslly/ui-components/TuvisSkeleton";

export const PageHeaderText: React.FC<{
  loading?: boolean;
  error?: string;
  licenseData?: LicenseData;
}> = ({ loading, error, licenseData }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.headerText}>
      {!error && (
        <TuvisSkeleton loading={loading} height="32px" width="350px" className={styles.seatsHeader}>
          <div className={styles.seatsHeader}>
            <div data-testid={`page-header-users`} className={styles.badge}>
              <FaUserCheck />
              <span>
                {` ${t("user_management.users_count", {
                  activeSeats: numberWithCommas(licenseData?.activeSeats ?? 0),
                })}`}
              </span>
            </div>
            {licenseData?.numOfSeats ? (
              <div data-testid={`page-header-purchased-licenses`} className={styles.badge}>
                <FaUserShield />
                <span>
                  {` ${t("user_management.purchased_licenses", {
                    numOfSeats: numberWithCommas(licenseData?.numOfSeats ?? 0),
                  })}`}
                </span>
              </div>
            ) : null}
            {licenseData?.numOfUsedSeats ? (
              <div data-testid={`page-header-consumed-licenses`} className={styles.badge}>
                <FaRegIdCard />
                <span>
                  {` ${t("user_management.consumed_licenses", {
                    numOfUsedSeats: numberWithCommas(licenseData?.numOfUsedSeats ?? 0),
                  })}`}
                </span>
              </div>
            ) : null}
          </div>
        </TuvisSkeleton>
      )}
    </div>
  );
};
